import React from 'react';
import HomePage from './HomePage';

const Home = () => <HomePage />;

export default Home;
